export function portalToOption(portal) {
  return {
    value: portal.id,
    label: `${portal.name} (${portal.namespace})`,
  };
}
